import React, { useState } from 'react'
import { MDBBtn } from 'mdb-react-ui-kit'
import { LeaderTermsStore } from '../LeaderTermsReviewer/LeaderTermsReviewer.component'
import UserProfileService from '../../../../shared/services/UserProfile.service'
import { toast } from 'react-toastify'
import LoadingSpinner from '../../../../components/shared/LoadingSpinner.component'

export const ResetGuidelineButton = ({ term }) => {
  const [loading, setLoading] = useState(false)

  const reestGuideline = async () => {
    setLoading(true)

    try {
      await LeaderTermsStore.UserTerm.delete()
      await LeaderTermsStore.fetch(UserProfileService.getUserId())
    } catch (err) {
      toast.error(err.message)
    }

    setLoading(false)
  }

  if (
    UserProfileService.isA(['system-admin', 'internal-admin', 'agency-owner'], true) &&
    LeaderTermsStore.hasAccepted()
  )
    return (
      <MDBBtn type='button' tag='a' disabled={loading} color='danger' onClick={reestGuideline}>
        Reset Leader Guidelines {loading ? <LoadingSpinner /> : <></>}
      </MDBBtn>
    )

  return <></>
}
